import React from "react";
import { RichTextElement } from "@kontent-ai/gatsby-components";
import useDisclaimerData from "@staticQueries/masterDisclaimerQuery";
import { Container } from "@ui";
import { LinkedImage } from "@global";

const MasterDisclaimer = () => {
  const data = useDisclaimerData();
  return (
    <div className="bg-lightGray py-7">
      <Container>
        <small className="[&_figure:]:inline-block [&_*]:text-sm [&_*]:leading-[160%] [&_*]:text-brown [&_a]:underline [&_figure:first-child]:pb-[30px] [&_figure:first-child]:pr-[30px] [&_figure:first-child]:pt-3 [&_figure:nth-child(2)]:pb-[40px] [&_figure]:inline-block [&_p]:font-light [&_strong]:font-medium">
          <RichTextElement
            value={data.value}
            linkedItems={data.modular_content}
            resolveLinkedItem={(linkedItem: any, domNode: any) => {
              const isLinkedImage = domNode.attribs["data-rel"] === "component";
              return (
                <>
                  {isLinkedImage && (
                    <LinkedImage
                      image={linkedItem.elements.image}
                      url={linkedItem.elements.url}
                    />
                  )}
                </>
              );
            }}
          />
        </small>
      </Container>
    </div>
  );
};

export default MasterDisclaimer;
